import $ from "jquery";
import { MouseEvent, TouchEvent } from "react";

export default function Reset({onClick}: {onClick?: (event: MouseEvent | TouchEvent) => void}) {
  return (
		<div
			className="reset"
			onClick={(event) => {
				event.stopPropagation();
				const $target = $(event.target);
				const $fsInput = $target.parents(".fs-container").find(".fs-input");
				if ($fsInput?.length) {
					$fsInput.val("");
					$fsInput.trigger("focus");
					$fsInput.trigger("keyup.fs");
				}
				onClick?.(event);
			}}
		>
			<svg>
				<g>
					<line x1="20%" y1="30%" x2="80%" y2="30%"></line>
					<line x1="80%" y1="30%" x2="80%" y2="70%"></line>
					<line x1="80%" y1="70%" x2="20%" y2="70%"></line>
					<line x1="20%" y1="70%" x2="30%" y2="60%"></line>
					<line x1="20%" y1="70%" x2="30%" y2="80%"></line>
				</g>
			</svg>
		</div>
	);
}
